<script lang="ts">
    import { createEventDispatcher } from "svelte"
    import Icon from "../../../../widgets/Icon.svelte"
    import { mdiChevronRight, mdiChevronDown, mdiCheck, mdiAlert } from "@mdi/js"

    import { tooltip } from "../../../../../utils"
    import { RuleEngine } from "../RuleEngine"
    import { setObjectValuesToNull } from "../utils"
    import inputfields from "./"

    export let ftpAssetsUrl: string
    export let currentChoices = null
    export let value: {
        [key: string]: any
    } = {}
    export let name: string = null
    export let stepCompletedDependsOn: OfferAssistantDependsOnRule[]
    export let dependsOn: OfferAssistantDependsOnRule[]
    export let label: string
    export let subFields: OfferAssistantSubField[] = []
    export let selected: boolean = false
    export let values: { [key: string]: any }
    values = values || null

    const dispatch = createEventDispatcher()
    const ruleEngine = new RuleEngine()
    let displayComponent: boolean = true
    let stepCompleted: boolean = false
    let stepEntered: boolean = false
    let invalidConfig: boolean = false

    const select = () => {
        stepEntered = true
        dispatch("select", {
            name,
        })
    }

    const onInvalidConfig = (e: CustomEvent) => {
        invalidConfig = e.detail
    }

    $: {
        if (selected) {
            stepEntered = true
        }
        if (values && dependsOn) {
            displayComponent = ruleEngine.resolve(dependsOn, values)
        }

        // Reset Object
        if (!displayComponent) {
            setObjectValuesToNull(value)
        }

        if (values && stepCompletedDependsOn) {
            stepCompleted = ruleEngine.resolve(stepCompletedDependsOn, values)
        }
        if (stepCompleted && stepEntered) {
            dispatch("completed", { completed: true })
        } else {
            dispatch("completed", { completed: false })
        }
    }
</script>

{#if displayComponent}
    <div
        class="nav-item {name}"
        role="button"
        tabindex="0"
        on:click="{select}"
        on:keydown
        class:selected
        class:invalid="{invalidConfig}"
        class:completed="{stepCompleted && stepEntered}"
    >
        <div class="title">
            {#if invalidConfig}
                <div
                    use:tooltip="{{
                        content: 'Die zuvor gewählten Optionen sind ungültig für die aktuelle Konfiguration!',
                    }}"
                >
                    <Icon path="{mdiAlert}" size="0.8" />
                </div>
            {:else if stepCompleted && stepEntered}
                <Icon path="{mdiCheck}" size="0.8" />
            {/if}
            {label ? label : "..."}
            <div class="chevron">
                <Icon path="{selected ? mdiChevronDown : mdiChevronRight}" />
            </div>
        </div>
    </div>

    {#if subFields.length}
        <div class="config" class:hidden="{!selected}">
            {#each subFields as field}
                <svelte:component
                    this="{inputfields[field.widget] || inputfields.default}"
                    {...field}
                    {values}
                    bind:value="{value[field.name]}"
                    {currentChoices}
                    on:invalid-config="{onInvalidConfig}"
                    {ftpAssetsUrl}
                />
            {/each}
        </div>
    {/if}
{/if}
